/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import AchievementLevel from '../../../common/components/AchievementLevel';
import AchievementCategoryName from '../../../common/components/AchievementCategoryName';
import UnlockedBy from './UnlockedBy';
import Icon from 'flarum/common/components/Icon';
export default class AchievementUsersHero extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      achievementLevel,
      loading
    } = this.attrs;
    if (!achievementLevel || loading) {
      return null;
    }
    const achievement = achievementLevel.achievement();
    const category = achievement.category();
    return m("div", {
      className: "AchievementUsersHero Hero"
    }, !loading && achievementLevel && [m("div", {
      className: "AchievementUsersHero-breadcrumbs"
    }, m(Link, {
      href: app.route('achievements', {
        category: category.id()
      }),
      className: "AchievementUsersHero-categoryName"
    }, m(AchievementCategoryName, {
      category: category
    })), m("span", null, m(Icon, {
      name: "fas fa-chevron-right"
    })), m(Link, {
      href: app.route('achievement', {
        id: achievement.id()
      }),
      className: "AchievementUsersHero-achievementName"
    }, achievement.name())), m(AchievementLevel, {
      achievementLevel: achievementLevel,
      showDesc: true
    }), m("div", {
      className: "AchievementUsersHero-unlockedBy"
    }, m(UnlockedBy, {
      achievementLevel: achievementLevel
    }))]);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementUsersHero', AchievementUsersHero);